<template>
  <div :style="bfactorStyle">
    <div class="box-head">Tertiary structure rendered by ACI</div>

    <div class="box-tool">
      <a :href="$store.state.host+`/dokhlab/actions/ohm/result?id=${task.id}&file=aci-pdb`">{{task.id}}-aci.pdb</a>
    </div>

    <div v-if="!showStructure">
      <el-button type="text" @click.native="viewStructure">View Structure</el-button>
    </div>

    <div v-show="showStructure" v-loading="showStructure&&!structureReady">
      <ngl-view class="ngl-view" id="1" ref="ngl" :height="600" :nameWidth="200"></ngl-view>
    </div>
  </div>
</template>

<script>
// import interpolate from 'color-interpolate'
// import { saveAs } from 'file-saver'
import NglView from './NglView/NglView.vue'
// import { bus } from '../bus.js'
// import * as NGL from 'ngl'

export default {
  name: 'Bfactor',

  data () {
    return {
      showStructure: false,
      structureReady: false,
      active_site: [],
      allosteric_site: [],
      bfactorStyle: {
        width: '100%',
        margin: '20px 0px',
        position: 'relative',
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-khtml-user-select': 'none',
        '-ms-user-select': 'none'
      },
      paths: {}
    }
  },

  props: [ 'value' ],

  components: {
    NglView
  },

  computed: {
    task () {
      return this.$store.state.task
    }
  },

  methods: {
    viewStructure () {
      this.showStructure = true
      this.$nextTick(() => {
        this.checkTask()
      })
    },

    checkTask () {
      let v = this
      if (this.task) {
        v.$refs.ngl.load(new Blob([v.task.results.bfactor], {type: 'text/plain'}), { ext: v.task.par.structure_type }).then(obj => {
          obj.setColor('bfactor')
        })

        this.structureReady = true
      } else {
        setTimeout(() => { v.checkTask() }, 500)
      }
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.ngl-view {
  /*
  box-shadow: 0 0 5px #888888;
  border: 1px solid #eeeeee;
  margin: 20px 0px;
  */
}

.box-head {
  padding: 10px;
  border-bottom: 1px solid #eeeeee;
  background-color: $theme-color;
  font-weight: 700;
  color: white;
}

.box-tool {
  padding:10px 0px;
}

</style>
